import { writable, get } from 'svelte/store';
export default class DataProvider {
    constructor(options) {
        this._placeholder = options.placeholder;
        this._noResults = options.noResults;
        this._cta = options.cta;
        this._structureKeys = options.structureKeys;
        this._showSiteUrl = options.showSiteUrl;
        this._resultUrl = options.resultUrl;
        this._template = options.template;
        this._groupId = options.groupId;
        this._endpoint = options.endpoint;
        this._whispererEndpoint = options.whispererEndpoint;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const optionsFromJson = JSON.parse(options.types);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this._types = Array.isArray(optionsFromJson) ? optionsFromJson : [];
        this._searchString = writable('');
        this._type = writable('');
        this._arrowCounter = -1;
        this._uniqueId = Math.floor(Math.random() * 1000);
    }
    get placeholder() {
        return this._placeholder;
    }
    get noResults() {
        return this._noResults;
    }
    get cta() {
        return this._cta;
    }
    get showSiteUrl() {
        return this._showSiteUrl;
    }
    get resultUrl() {
        return this._resultUrl;
    }
    get template() {
        return this._template;
    }
    get groupId() {
        return this._groupId;
    }
    get endpoint() {
        return this._endpoint;
    }
    get whispererEndpoint() {
        return this._whispererEndpoint;
    }
    get uniqueId() {
        return this._uniqueId;
    }
    get arrowCounter() {
        return this._arrowCounter;
    }
    set arrowCounter(value) {
        this._arrowCounter = value;
    }
    // searchString
    set searchString(string) {
        this._searchString.set(string);
    }
    get searchString() {
        return get(this._searchString);
    }
    get searchStringSubs() {
        return this._searchString;
    }
    get searchParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get("q") || "";
    }
    // types
    get types() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return this._types.map((typeOption) => {
            if (typeOption.children) {
                return Object.assign(Object.assign({}, typeOption), { opened: false });
            }
            return Object.assign({}, typeOption);
        });
    }
    set type(value) {
        this._type.set(value);
    }
    get type() {
        return get(this._type);
    }
    get typeParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const type = urlParams.get("typ") || "";
        return type;
    }
    // pager
    get pageParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const page = urlParams.get("strana");
        return page ? parseInt(page) : 1;
    }
    get pageSizeParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const pageSize = urlParams.get("pocet");
        return pageSize ? parseInt(pageSize) : 10;
    }
    get apiStructureKeys() {
        if (typeof this._structureKeys === "string") {
            return this._structureKeys.split("|");
        }
        else {
            return [];
        }
    }
}
